<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách sạn</div>
                <div class="child-w-80">
                  <select v-model="searchParams.hotelId">
                    <option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></option>
                  </select>
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Ngày</div>
                <div class="child-w-80">
                  <!-- :date-data="agentItem.representative_card_date" -->
                  <!-- v-model="agentItem.representative_card_date" -->
                  <!-- @changeCalendar="onChangeDate2" -->
                  <calendar-select
                    style="display: block; width: 200px"
                    mode="date"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">Báo cáo trang thiết bị</span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div v-loading="loading" class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              :auto-select-first-row="false"
              :auto-size-cell="true"
              :row-selection="false"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- <div ref="echartBarchart" class="echart-barchart"></div> -->
    <!-- <bar-chart :options="optionChart"> </bar-chart> -->
    <!-- <vchart
      style="height: 400px"
      class="chart"
      :option="optionChart"
      autoresize
    /> -->

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Mã thiết bị: hiển thị mã thiết bị</li>
            <li>Tên thiết bị: hiển thị tên thiết bị</li>
            <li>Hạng phòng: Hiển thị tên hạng phòng</li>
            <li>
              Số lượng mỗi phòng: Số lượng của thiết bị được để tại mỗi phòng
            </li>
            <li>
              Số lượng tổng: bằng số thiết bị mỗi phòng* tổng số lượng phòng của
              hạng phòng đấy
            </li>
            <li>
              Tình trạng: tình trạng sử dụng của thiết bị gồm: Tốt, Cần sửa
              chữa, Cần thay thế
            </li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { getSourceApi } from '@/api/Statistics/source'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import { getAllHotel } from '@/api/hotel'
import {
  getListFreeRoom,
  getListFreeRoomExcel
} from '@/api/report_service/freeRoomReport'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import InfoBtn from './components/InfoBtn.vue'
import { downFile } from '@/utils/file-handler'

export default {
  components: {
    CalendarSelect,
    SelectWithSearchTable,
    InfoBtn
    // VChart
  },
  // provide: {
  //   [THEME_KEY]: 'dark'
  // },
  data() {
    return {
      dialogFormVisible: false,
      hotelList: [],
      loading: false,
      searchParams: {
        dateFrom: '',
        dateTo: '',
        hotelId: '',
        bookingCode: '',
        sourceId: ''
      },
      // optionChart: {
      //   tooltip: {
      //     trigger: 'axis',
      //     axisPointer: {
      //       type: 'shadow'
      //     }
      //   },
      //   grid: {
      //     left: '3%',
      //     right: '4%',
      //     bottom: '3%',
      //     containLabel: true
      //   },
      //   xAxis: [
      //     {
      //       type: 'category',
      //       data: ['haa', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      //       axisTick: {
      //         alignWithLabel: true
      //       }
      //     }
      //   ],
      //   yAxis: [
      //     {
      //       type: 'value'
      //     }
      //   ],
      //   series: [
      //     {
      //       name: 'Direct',
      //       type: 'bar',
      //       barWidth: '60%',
      //       data: [10, 52, 200, 334, 390, 330, 220]
      //     }
      //   ]
      // },
      sourceOptions: [],
      columnsSource: [
        {
          headerName: 'Mã nguồn',
          field: 'code',
          width: 100
        },
        {
          headerName: 'Mô tả',
          field: 'desc'
        }
      ],

      columns: [
        {
          headerName: this.$t('grid.column.equipmentCode'),
          field: 'hotel_nm',
          // cellClass: "grid-cell-centered",
          sortable: false
        },
        {
          headerName: this.$t('grid.column.equipmentName'),
          field: 'building_no',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.roomLevel'),
          field: 'name',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.quantityEachRoom'),
          field: 'name',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.quantityTotal'),
          field: 'name',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false
        },
        {
          headerName: this.$t('grid.column.status'),
          field: 'name',
          cellClass: 'grid-cell-centered',
          headerClass: 'ag-grid-header-cell-border-bottom',
          // maxWidth: 200,
          marryChildren: true,
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          children: [
            {
              headerName: this.$t('grid.column.good'),
              field: 'name'
            },
            {
              headerName: this.$t('grid.column.needRepair'),
              field: 'name'
            },
            {
              headerName: this.$t('grid.column.needReplace'),
              field: 'name'
            }
          ]
          // cellClass: "grid-cell-centered",
        }
      ],
      rows: []
    }
  },
  created() {
    this.getListSource()
    this.getListHotel()
  },
  mounted() {
    this.attachData()
    // this.importChart()
  },
  methods: {
    handleCommand(cmmd) {
      // this.$message('click on item ' + cmmd)
      switch (cmmd) {
        case 'pdf':
          break
        case 'excel':
          this.downloadExcel()
          break
        default:
          this.$message('click on item ' + cmmd)
          break
      }
    },
    // importChart() {
    //   let dom = this.$refs.echartBarchart
    //   console.log(dom)
    //   let myChart = echarts.init(dom, null, {
    //     renderer: 'canvas',
    //     useDirtyRect: false
    //   })
    //   if (this.option && typeof this.option === 'object') {
    //     myChart.setOption(this.option)
    //   }
    // },
    async getListSource() {
      const data = await getSourceApi({ isActive: 1 })
      this.sourceOptions = data.data
    },
    onSelectRowSource(val) {
      this.searchParams.sourceId = val.id
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    async attachData() {
      // this.loading = true

      const data = await getListFreeRoom()
      // this.loading = false
      data?.data.forEach(element => {
        this.rows = [
          ...this.rows,
          element,
          {
            name: ['Ghi chú: ', element.note].join(' '),
            isFullWidthRow: true
          }
        ]
      })
      // this.rows = data.data
    },
    async downloadExcel() {
      // this.loading = true
      const data = await getListFreeRoomExcel()
      const date = this.$moment().format('DD-MM-YYYY')
      downFile(data, 'bao_cao_trang_thiet_bi_' + date + '.xlsx')
    }
  }
}
</script>

<style lang="scss">
.button-containers-title {
  display: flex;
  /* margin-top: 20px; */
  justify-content: flex-end;
  align-items: flex-end;
  gap: 10px;
  .download-button {
    padding: 10px 10px;
  }
}
</style>
